export default "__VITE_ASSET__DJRfQWsa__"